<template>
  <div class="grid grid-cols-1 xxl:grid-cols-3 xxxl:grid-cols-4">
    <div class="xxl:col-span-2 xxxl:col-span-3 xxl:mr-2">
      <div v-if="isLoadingRequests">
        <p class="opacity-60">Finding requests</p>
        <span class="flex h-12 w-12 mx-auto mt-5">
          <span
            class="
              animate-ping
              absolute
              inline-flex
              h-12
              w-12
              rounded-full
              bg-primary
              opacity-75
            "
          ></span>
          <span
            class="relative inline-flex rounded-full h-12 w-12 bg-primary"
          ></span>
        </span>
      </div>

      <hr
        class="mb-2 mt-4 mr-8"
        style="
          border-top: 2px dotted #e3e3e3;
          border-bottom: none;
          border-left: none;
          border-right: none;
        "
      />

      <div v-if="showFilters" class="grid xxl:flex my-4">
        <p class="text-grey mr-3 my-auto">Location:</p>
        <vs-select class="w-full xxl:w-32" v-model="location">
          <vs-select-item
            :placeholder="'Placeholder'"
            :key="index"
            :value="item"
            :text="item.name"
            v-for="(item, index) in locations"
          />
        </vs-select>
        <vs-button
          class="ml-2 mt-2"
          v-if="location"
          size="small"
          @click="location = null"
          icon="close"
        ></vs-button>

        <p class="text-grey mr-3 mt-2 xxl:ml-6 xxl:my-auto">Venue:</p>
        <vs-select class="w-full xxl:w-32" v-model="venue">
          <vs-select-item
            :placeholder="'Placeholder'"
            :key="index"
            :value="item"
            :text="item.name"
            v-for="(item, index) in venues"
          />
        </vs-select>
        <vs-button
          class="ml-2 mt-2"
          v-if="venue"
          size="small"
          @click="venue = null"
          icon="close"
        ></vs-button>

        <p class="text-grey mr-3 my-auto mt-2 xxl:ml-6 xxl:my-auto">
          Caseworker:
        </p>
        <vs-select
          class="w-full xxl:w-auto"
          v-model="selectedFilterCaseworker"
          autocomplete
        >
          <vs-select-item
            :placeholder="'Placeholder'"
            :key="index"
            :value="item"
            :text="item.displayName"
            v-for="(item, index) in caseworkersAndMe"
          />
        </vs-select>
        <vs-button
          class="ml-2 mt-2"
          v-if="selectedFilterCaseworker"
          size="small"
          @click="selectedFilterCaseworker = null"
          icon="close"
        ></vs-button>
      </div>
      <div class="xxl:flex mb-4">
        <p class="text-grey mr-3 my-auto">Sort by:</p>
        <vs-select
          class="w-full mb-3 xxl:mb-0 xxl:w-64"
          v-model="selectedSortMode"
        >
          <vs-select-item
            :placeholder="'Placeholder'"
            :key="index"
            :value="item"
            :text="item.name"
            v-for="(item, index) in sortModes"
          />
        </vs-select>
        <p class="text-grey mr-3 xxl:ml-6 my-auto">Search:</p>
        <vs-input class="w-full xxl:w-64" v-model="searchText"></vs-input>
      </div>

      <hr
        class="my-2 mr-8"
        style="
          border-top: 2px dotted #e3e3e3;
          border-bottom: none;
          border-left: none;
          border-right: none;
        "
      />
      <div
        class="xxl:flex mb-4"
      >
        <vs-button
          @click="$refs.popupRejectedRequests.show(rejectedRequests)"
          class="text-sm"
          >Rejected requests</vs-button
        >
      </div>
    </div>

    <div class="col-span-2 order-last">
      <div
        v-if="!isLoadingRequests"
        class="pl-12 p-6"
        style="margin-left: -3rem"
      >
        <div v-if="requests.length == 0">
          <p class="text-grey">No requests found</p>
        </div>
        <div
          v-for="(enhRequest, index) in requests"
          :key="index"
          class="
            bg-white
            shadow-xl
            mb-4
            rounded-xl
            tablet:flex
            overflow-hidden
            grid grid-cols-3
            justify-between
            cursor-pointer
          "
          :style="{
            'background-color': isWarningcolor(enhRequest)
              ? 'rgb(255 244 244) !important'
              : '',
          }"
          @click="$refs.popupEditBooking.show(enhRequest)"
        >
          <div
            class="
              p-6
              px-8
              flex
              justify-between
              w-full
              col-span-2
              tablet:col-span-1
            "
          >
            <div>
              <h4>
                <span
                  v-if="isFlagged(enhRequest)"
                  class="material-icons text-primary"
                  >flag</span
                >
                {{
                  venues.find(
                    (v) =>
                      enhRequest.booking.venueDetailsId.id ===
                      v.venueDetailsId.id
                  ).name
                }}
                <span class="text-grey"
                  >- {{ enhRequest.booking.guestCount }} guests</span
                >
              </h4>
              <div class="flex" v-if="enhRequest.event">
                <vs-chip color="blue">
                  EVENT: {{ enhRequest.event.eventName }}
                </vs-chip>
              </div>
              <p class="text-grey">
                {{
                  enhRequest.bookingCustomer
                    ? enhRequest.bookingCustomer.name
                    : "No name"
                }}
                - arrival:
                {{ formattedArrival(enhRequest.booking) }}
                <span
                  class="tag-badge lg:ml-2"
                  v-if="getThemeTagString(enhRequest)"
                  >{{ getThemeTagString(enhRequest) }}</span
                >
              </p>
              <div>
                <span v-if="!enhRequest.booking.caseworker" class="text-danger">
                  No caseworker</span
                >

                <span
                  v-if="enhRequest.booking.caseworker"
                  class="text-primary bg-success"
                >
                  Caseworker:
                  {{ enhRequest.booking.caseworker.displayName }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="
              order-last
              tablet:order-0 tablet:col-span-1
              col-span-3
              w-full
              tablet:my-auto
            "
            @click="
              $event.stopPropagation();
              $event.preventDefault();
            "
          >
            <assign-caseworker-to-booking
              v-if="
                hasPermissionForActiveVenue(
                  'vp.vp.booking.acceptrequestpendingrequests'
                )
              "
              :booking="enhRequest.booking"
              @caseworker-assigned="searchRequests()"
            />
          </div>

          <div
            class="rounded-r-xxl p-6 px-8 tablet:order-last"
            style="background-color: #f0f2f4 !important; min-width: 10rem"
          >
            <div v-if="enhRequest.booking.totalPrice">
              <p class="text-grey leading-none"><small>Preorders</small></p>
              <p>
                <small>{{ enhRequest.booking.totalPrice }}</small>
              </p>
            </div>
            <div v-if="enhRequest.booking.budget">
              <p class="text-grey leading-none"><small>Budget</small></p>
              <p>
                <small>{{
                  formatPrice(
                    enhRequest.booking.budget / 100,
                    enhRequest.booking.budgetCurrency
                  )
                }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="xxl:col-span-1 col-span-3">
      <div class="bg-white shadow-xxl rounded-xxl p-6 px-8">
        <p><b>Number of requests</b></p>
        <p>{{ requests.length }}</p>

        <p class="mt-6"><b>Unassigned requests</b></p>
        <p>{{ requests.filter((r) => !r.booking.caseworker).length }}</p>
      </div>
    </div>

    <popup-edit-booking
      ref="popupEditBooking"
      @booking-updated="handleBookingUpdated"
    />
    <popup-rejected-requests
      ref="popupRejectedRequests"
      @request-activated="handleRequestActivated"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";
import PopupEditBooking from "../../../marcom/popups/PopupEditBooking.vue";
import PopupRejectedRequests from "../../../marcom/popups/PopupRejectedRequests.vue";
import AssignCaseworkerToBooking from "../../components/bookings/AssignCaseworkerToBooking.vue";
import moment from "moment";
import * as _ from "lodash";
import { BOOKING_STATE } from "../../../../../store/modules/marcom/data-model/bookings";

export default {
  components: {
    PopupEditBooking,
    PopupRejectedRequests,
    AssignCaseworkerToBooking,
  },
  props: {
    venueSpecific: Boolean,
    showFilters: Boolean,
  },
  data() {
    return {
      isLoadingRequests: false,
      venue: null,
      location: null,
      selectedFilterCaseworker: null,
      searchText: "",
      caseworkersAndMe: [],
      sortModes: [
        { name: "Preorder amount", type: "PREORDER" },
        { name: "Oldest (note) first", type: "OLDEST-NOTE" },
      ],
      selectedSortMode: undefined,
      THEME_OTHER: "THEME:OTHER",
    };
  },
  async mounted() {
    if (!this.showFilters) {
      this.venue = this.activeVenue;
      this.venue.venueDetailsId = { id: this.activeVenue.venueId };
    }

    await this.searchRequests();
    this.selectedSortMode = this.sortModes[0];

    await this.$store.dispatch(
      "marcomBooking/" + BOOKING_ACTIONS.GetCaseworkers
    );

    await this.$store.dispatch(
      "marcomBooking/" + BOOKING_ACTIONS.GetRejectedRequests,
      this.activeVenue.venueId
    );

    this.caseworkersAndMe = [
      {
        displayName: "ME",
        userId: { id: this.me.userId },
      },
    ];
    this.caseworkersAndMe = _.concat(this.caseworkersAndMe, this.caseworkers);
    //this.selectedSortMode = this.sortModes[0];
  },

  methods: {
    async searchRequests() {
      this.isLoadingRequests = true;

      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.SearchRequests,
        {}
      );
      await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetVenues, {});
      this.isLoadingRequests = false;
    },
    isWarningcolor(enhRequest) {
      if (!enhRequest.booking.caseworker) return true;

      return this.isFlagged(enhRequest);
    },
    isFlagged(enhRequest) {
      var last24 = moment(new Date());
      last24.add(-24, "hours");
      var recentNote = enhRequest.booking.notes
        .map((bn) => moment(bn.created))
        .filter((nt) => nt > last24).length;
      var recentCahngeLog = enhRequest.booking.changeLog
        .map((bn) => moment(bn.created))
        .filter((nt) => nt > last24).length;
      return recentNote == 0 && recentCahngeLog == 0;
    },
    formattedArrival(booking) {
      let date = moment(booking.arrival);
      return date.format("DD/MM - YYYY HH:mm");
    },
    formatPrice(decAmount, currency) {
      var options = {};
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

      if (currency)
        _.assign(options, { style: "currency", currency: currency });
      var formatter = new Intl.NumberFormat("en-US", options);

      return formatter.format(decAmount); /* $2,500.00 */
    },
    getOrderlineTotalPrice(orderLine) {
      const intAmount = orderLine.quantity * orderLine.unitPrice.value;
      const decAmount = intAmount / 100;
      return decAmount;
    },
    getTotalPrice(booking) {
      var tot = 0;
      for (const orderLine of booking.orderLines) {
        tot += this.getOrderlineTotalPrice(orderLine);
      }
      return tot;
    },
    async handleBookingUpdated() {
      await this.searchRequests();
      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.GetRejectedRequests,
        this.activeVenue.venueId
      );
    },
    getThemeTagString(enhancedBooking) {
      if (!enhancedBooking.booking.tags) return "";

      var result = enhancedBooking.booking.tags
        .map((bookingTag) => {
          if (bookingTag === null || bookingTag.indexOf("BOOKING_TYPE") >= 0)
            return "";
          var translation = this.tags.find((t) => t.tag === bookingTag);
          if (translation !== undefined)
            return translation.translations.find((t) => t.languageCode === "EN")
              .translation;

          if (_.startsWith(_.toUpper(bookingTag), `${this.THEME_OTHER}|`)) {
            return bookingTag.substring(`${this.THEME_OTHER}|`.length);
          }

          return bookingTag;
        })
        .filter((t) => t !== "")
        .join(", ");

      return result;
    },
    compareByPreorderCapElseByArrival(aBooking, bBooking) {
      let preorderCap = 5000;
      if (
        this.getTotalPrice(aBooking) > preorderCap &&
        this.getTotalPrice(bBooking) <= preorderCap
      ) {
        return -1; // a before b
      }
      if (
        this.getTotalPrice(aBooking) <= preorderCap &&
        this.getTotalPrice(bBooking) > preorderCap
      ) {
        return 1; //b before a
      }
      if (
        this.getTotalPrice(aBooking) > preorderCap &&
        this.getTotalPrice(bBooking) > preorderCap
      ) {
        return this.getTotalPrice(bBooking) - this.getTotalPrice(aBooking); //highest amount first
      }
      if (
        this.getTotalPrice(aBooking) <= preorderCap &&
        this.getTotalPrice(bBooking) <= preorderCap
      ) {
        return this.compareByCreated(aBooking, bBooking);
      }
    },
    compareByCreated(aBooking, bBooking) {
      let aDate = moment(aBooking.created);
      let bDate = moment(bBooking.created);
      if (aDate.isBefore(bDate)) return -1; // a before b
      if (aDate.isAfter(bDate)) return 1; //b before a
      if (aDate.isSame(bDate)) return 0;
    },
    compareByInternalNoteCreatedElseByCreated(aBooking, bBooking) {
      let aDate = moment(aBooking.created);
      if (aBooking.notes && aBooking.notes.length > 0) {
        //get newest note, so sort notes newest first
        let notes = [...aBooking.notes].sort(this.compareInternalNotes);
        aDate = moment(notes[0].created);
      }

      let bDate = moment(bBooking.created);
      if (bBooking.notes && bBooking.notes.length > 0) {
        //get newest note, so sort notes newest first
        let notes = [...bBooking.notes].sort(this.compareInternalNotes);
        bDate = moment(notes[0].created);
      }

      if (aDate.isBefore(bDate)) return -1; //a before b
      if (aDate.isAfter(bDate)) return 1; //b before a
      if (aDate.isSame(bDate)) return 0;
    },
    compareInternalNotes(xNote, yNote) {
      let xNoteDate = moment(xNote.created);
      let yNoteDate = moment(yNote.created);
      if (xNoteDate.isBefore(yNoteDate)) return 1;
      if (xNoteDate.isAfter(yNoteDate)) return -1;
      if (xNoteDate.isSame(yNoteDate)) return 0;
    },

    compareSearch(request) {
      const { booking, bookingCustomer } = request;
      
      if (booking.arrival.includes(this.searchText)) return true;

      if (bookingCustomer && bookingCustomer.displayName.includes(this.searchText)) return true;

      if (bookingCustomer && bookingCustomer.email.includes(this.searchText)) return true;

      return false;
    },
    async handleRequestActivated(booking) {
      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.ReopenRequest,
        booking
      );
      await this.searchRequests();
     this.selectedSortMode = this.sortModes[1];
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      enhancedRequests: "marcomBooking/enhancedRequests",
      rejectedRequests: "marcomBooking/rejectedRequests",
      locations: "marcom/locations",
      tags: "marcom/allBookingTags",
      caseworkers: "marcomBooking/caseworkers",
      me: "users/me",
    }),
    venues() {
      var result = this.$store.state.marcom.venues;

      if (this.location)
        result = result.filter((v) => v.locationId.id == this.location.id);

      if (result.length == 0)
        result.push({
          name: "No venues",
          isNoResult: true,
        });

      return result;
    },
    requests() {
      var result = this.enhancedRequests;

      if (this.venue)
        result = result.filter(
          (r) => r.booking.venueDetailsId.id == this.venue.venueDetailsId.id
        );
      else
        result = result.filter((r) =>
          this.venues
            .filter((v) => !v.isNoResult)
            .map((v) => v.venueDetailsId.id)
            .includes(r.booking.venueDetailsId.id)
        );

      if (this.selectedFilterCaseworker)
        result = result.filter(
          (r) =>
            r.booking.caseworker &&
            r.booking.caseworker.userId.id ==
              this.selectedFilterCaseworker.userId.id
        );

      for (const enhRequest of result) {
        enhRequest.booking.totalPrice = this.formatPrice(
          this.getTotalPrice(enhRequest.booking),
          enhRequest.booking.orderLines.length > 0
            ? enhRequest.booking.orderLines[0].unitPrice.currency
            : ""
        );
      }

      //var now = new Date();
      if (this.selectedSortMode) {
        switch (this.selectedSortMode.type) {
          case "PREORDER": {
            result.sort((a, b) => {
              return this.compareByPreorderCapElseByArrival(
                a.booking,
                b.booking
              );
              // if (a.booking.totalPrice > 5000) {
              //   return b.booking.totalPrice - a.booking.totalPrice;
              // }
              // return (
              //   (Date.parse(a.booking.arrival) - now < 0
              //     ? Date.parse(a.booking.arrival)
              //     : Date.parse(a.booking.arrival) - now) -
              //   (Date.parse(b.booking.arrival) - now < 0
              //     ? Date.parse(b.booking.arrival)
              //     : Date.parse(b.booking.arrival) - now)
              // );
            });
            break;
          }
          case "OLDEST-NOTE": {
            result = result.sort((a, b) => {
              return this.compareByInternalNoteCreatedElseByCreated(
                a.booking,
                b.booking
              );
            });
            break;
          }
        }
      }

      // SearchBy: Email, name, date
      if (!this.searchText) return result;
      let searchResults = result.filter((request) => {
        return this.compareSearch(request);
      });

      return searchResults;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-grid {
  @media only screen and (max-width: 801px) {
    display: block;
    grid-template-columns: 1fr 2fr;
  }

  display: grid;
  grid-template-columns: 5fr 2fr;
}

.vc-container {
  background: transparent;
  border: none;
}

.tag-badge {
  background: #b5b8bb50;
  color: #2222227e;
  padding: 1px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
}
</style>
